import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSwitch,{attrs:{"hide-details":""},on:{"change":_vm.handleToggle},model:{value:(_vm.toggleValue),callback:function ($$v) {_vm.toggleValue=$$v},expression:"toggleValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }